import React from 'react';
import { Skeleton } from '@mui/material';

import scss from './PreviewTextSkeleton.module.scss';

function PreviewTextSkeleton() {
  return (
    <div className={scss.wrapper}>
      <Skeleton variant='text' animation='wave' width='95%' />
      <Skeleton variant='text' animation='wave' width='88%' />
      <Skeleton variant='text' animation='wave' width='60%' />
    </div>
  );
}

export default PreviewTextSkeleton;
